import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup } from '@angular/forms';

export interface ScriptEditorDialogData {
  scriptFormGroup: FormGroup;
  aiEditInProgress: boolean;
  previousFinalPrompt: string;
  undoFinalPromptEdit: () => void;
  formControlName?: string; // Optional: 'whatsappChatPrompt' for WhatsApp mode, undefined for finalPrompt mode
  dialogTitle?: string; // Optional: Dialog title
  placeholder?: string; // Optional: Placeholder text
}

@Component({
  selector: 'hour4u-admin-script-editor-dialog',
  templateUrl: './script-editor-dialog.component.html',
  styleUrls: ['./script-editor-dialog.component.scss']
})
export class ScriptEditorDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ScriptEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ScriptEditorDialogData
  ) { }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({ saved: true });
  }

  isFinalPromptMode(): boolean {
    // If formControlName is not provided or is not 'whatsappChatPrompt', it's finalPrompt mode
    return !this.data.formControlName || this.data.formControlName !== 'whatsappChatPrompt';
  }
}
